"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactToggle = _interopRequireDefault(require("react-toggle"));

var _Switch = _interopRequireDefault(require("./Switch.style"));

var Switch = function Switch(_ref) {
  var checked = _ref.checked,
      defaultChecked = _ref.defaultChecked,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      text = _ref.text,
      style = _ref.style,
      className = _ref.className,
      textClassName = _ref.textClassName,
      textStyle = _ref.textStyle,
      size = _ref.size;
  var toggleProps = {
    checked: checked,
    defaultChecked: defaultChecked,
    onChange: onChange,
    disabled: disabled
  };

  if (typeof checked !== 'boolean') {
    delete toggleProps.checked;
  }

  return _react.default.createElement(_Switch.default, {
    style: style,
    disabled: disabled,
    className: className
  }, _react.default.createElement(_reactToggle.default, (0, _extends2.default)({
    className: size === 'small' ? 'small' : ''
  }, toggleProps, {
    icons: false
  })), _react.default.createElement("span", {
    style: textStyle,
    className: textClassName
  }, text));
};

Switch.propTypes = {
  checked: _propTypes.default.bool,
  defaultChecked: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool,
  style: _propTypes.default.shape({}),
  text: _propTypes.default.string,
  className: _propTypes.default.string,
  textClassName: _propTypes.default.string,
  textStyle: _propTypes.default.shape({}),
  size: _propTypes.default.oneOf(['small', 'medium'])
};
Switch.defaultProps = {
  checked: undefined,
  defaultChecked: undefined,
  disabled: false,
  style: {},
  text: '',
  className: '',
  textClassName: '',
  textStyle: {},
  onChange: function onChange() {},
  size: 'small'
};
var _default = Switch;
exports.default = _default;